__turbopack_context__.v({
  "--address": "question-ad-profile-module-scss-module__iR0eqq__--address",
  "--description": "question-ad-profile-module-scss-module__iR0eqq__--description",
  "--is-photo-voting": "question-ad-profile-module-scss-module__iR0eqq__--is-photo-voting",
  "--phone-number": "question-ad-profile-module-scss-module__iR0eqq__--phone-number",
  "--split": "question-ad-profile-module-scss-module__iR0eqq__--split",
  "--title": "question-ad-profile-module-scss-module__iR0eqq__--title",
  "__content": "question-ad-profile-module-scss-module__iR0eqq____content",
  "__content-container": "question-ad-profile-module-scss-module__iR0eqq____content-container",
  "__image": "question-ad-profile-module-scss-module__iR0eqq____image",
  "__social-bar": "question-ad-profile-module-scss-module__iR0eqq____social-bar",
  "__whole-ad-link": "question-ad-profile-module-scss-module__iR0eqq____whole-ad-link",
  "question-ad-profile": "question-ad-profile-module-scss-module__iR0eqq__question-ad-profile",
});
